export enum ErrorPageStatusEnum {
  status401 = 401,
  status404 = 404,
  status500 = 500,
  status503 = 503,
  desktopOnly = 'desktop-only',
  mobileOnly = 'mobile-only',
  qrCodeScanFailed = 'qr-code-scan-failed',
}
